import { exists } from '@/api'

export interface BatchReserveReturnWaitingCollectionForwardingCandidateListCondition {
  dateFrom: string
  dateTo: string
  holdingBranchCode: string
  outputCondition: string
  assignOrder: string
  customAssignOrder: string
}

export function BatchReserveReturnWaitingCollectionForwardingCandidateListConditionFromJSON(
  json: any
): BatchReserveReturnWaitingCollectionForwardingCandidateListCondition {
  const _json = JSON.parse(json)

  return {
    dateFrom: exists(_json, 'date_from') ? _json.date_from : '',
    dateTo: exists(_json, 'date_to') ? _json.date_to : '',
    holdingBranchCode: exists(_json, 'holding_branch_code')
      ? _json.holding_branch_code
      : '',
    outputCondition: exists(_json, 'output_condition')
      ? _json.output_condition
      : '1',
    assignOrder: exists(_json, 'assign_order') ? _json.assign_order : '1',
    customAssignOrder: exists(_json, 'custom_assign_order')
      ? _json.custom_assign_order
      : ''
  }
}
